import { validateDate } from '@/utils/validators/date';
import * as yup from 'yup';

interface PageValidationSchema {
  tel: yup.ObjectSchema<any>;
  cpf: yup.ObjectSchema<any>;
  fullName: yup.ObjectSchema<any>;
  motherName: yup.ObjectSchema<any>;
  birthDate: yup.ObjectSchema<any>;

  [key: string]: yup.ObjectSchema<any>;
}

interface useValidationProps {
  userDataNotFound: boolean;
}
export function useValidation({ userDataNotFound }: useValidationProps) {
  const pageValidationSchema: PageValidationSchema = {
    tel: yup.object().shape({
      tel: yup.string().tel().required('O telefone é obrigatório'),
    }),
    cpf: yup.object().shape({
      cpf: yup.string().cpf().required('O CPF é obrigatório'),
    }),
    fullName: yup.object().shape({
      fullName: yup.string().when([], {
        is: () => userDataNotFound,
        then: () => yup.string().required('O nome é obrigatório'),
      }),
    }),
    motherName: yup.object().shape({
      motherName: yup.string().when([], {
        is: () => userDataNotFound,
        then: () => yup.string().required('O nome da mãe é obrigatório'),
      }),
    }),
    birthDate: yup.object().shape({
      birthDate: yup.string().when([], {
        is: () => userDataNotFound,
        then: () =>
          yup
            .string()
            .test('date', 'Data inválida', function (value) {
              // @ts-ignore
              return validateDate.call(this, value, [18, 120]);
            })
            .required('A data de nascimento é obrigatória'),
      }),
    }),
  };

  const personalDataSchema = yup.object().shape({
    email: yup
      .string()
      .email('O e-mail digitado não é válido')
      .required('O e-mail é obrigatório'),
    tel: yup.string().tel().required('O telefone é obrigatório'),
    cpf: yup.string().cpf().required('O CPF é obrigatório'),
    autorizarContato: yup
      .bool()
      .oneOf([true], 'Você deve aceitar para continuar'),
    fullName: yup.string().when([], {
      is: () => userDataNotFound,
      then: () => yup.string().required('O nome é obrigatório'),
    }),
    motherName: yup.string().when([], {
      is: () => userDataNotFound,
      then: () => yup.string().required('O nome da mãe é obrigatório'),
    }),
    birthDate: yup.string().when([], {
      is: () => userDataNotFound,
      then: () =>
        yup
          .string()
          .test('date', 'Data inválida', function (value) {
            // @ts-ignore
            return validateDate.call(this, value, [18, 120]);
          })
          .required('A data de nascimento é obrigatória'),
    }),
  });

  return { pageValidationSchema, personalDataSchema };
}
